import { Suspense, lazy } from "react";
import { slugIdConstants } from "types/UserBookStatusType";
import Icon from "hardcover-ui/components/Icon";
import faCheckCircle from "icons/solid/circle-check.svg";
import { CoverProps } from "hardcover-ui/theme/components/cover";
import useMount from "hooks/useMount";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { useUserBookStatus } from "store/bookButton/bookButtonSelector";

const CoverBookButton = lazy(() => import("./CoverBookButton"));

export default function CoverStatus({
  bookId,
  size,
  referrerId,
}: {
  bookId: number;
  size: CoverProps["size"];
  referrerId?: number;
}) {
  const statusId = useUserBookStatus(bookId);
  const isLoggedIn = useIsLoggedIn();
  const mounted = useMount();

  if (!mounted || !isLoggedIn) {
    return <></>;
  }

  return (
    <>
      {statusId === slugIdConstants.read && (
        <Icon
          icon={faCheckCircle}
          size="md"
          className="fill-green-500 absolute top-1 right-1 z-10 bg-white rounded-full group-hover:hidden"
        />
      )}

      {size !== "xs" && (
        <Suspense>
          <CoverBookButton bookId={bookId} statusId={statusId} referrerId={referrerId} />
        </Suspense>
      )}
    </>
  );
}
